import { render, staticRenderFns } from "./AddSceneToTagModal.vue?vue&type=template&id=5791ac54&scoped=true"
import script from "./AddSceneToTagModal.vue?vue&type=script&lang=js"
export * from "./AddSceneToTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791ac54",
  null
  
)

export default component.exports